module.exports = __webpack_public_path__ + "media/stylesheets/images/icons/prev_hover-2ef678715b6fec3e4bea4a1c51ca3807.svg";